import React, { Component, Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './school-team.styles'
import Paper from 'pobble-components/dist/paper'
import Spinner from 'pobble-components/dist/spinner'
import Teachers from './teachers/teachers.container'
import PendingTeachers from './pending-teachers/pending-teachers.container'

class SchoolTeam extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
    this.props.onMount()
  }
  render() {
    const { classes, pending } = this.props
    return (
      <Fragment>
        {!pending && (
          <Fragment>
            <Paper className={classes.container}>
              <Teachers />
            </Paper>
            <Paper className={classes.container}>
              <PendingTeachers />
            </Paper>
          </Fragment>
        )}
        {pending && <Spinner className={classes.spinner} />}
      </Fragment>
    )
  }
}

export default injectSheet(styles)(SchoolTeam)
